import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {
  AddEJournalFailure,
  AddEJournalRequest,
  AddEJournalSuccess,
  DeleteMyJOurnalRecordsFailure,
  DeleteMyJOurnalRecordsRequest,
  DeleteMyJOurnalRecordsSuccess,
  EditRecordsFailure,
  EditRecordsRequest,
  EditRecordsSuccess,
  FetchActivityTypeFailure,
  FetchActivityTypeRequest,
  FetchActivityTypeSuccess,
  FetchColorTypeFailure,
  FetchColorTypeRequest,
  FetchColorTypeSuccess,
  FetchDailyMealAndDrinkTrackerFailure,
  FetchDailyMealAndDrinkTrackerRequest,
  FetchDailyMealAndDrinkTrackerSuccess,
  FetchDailyScreenActivityFailure,
  FetchDailyScreenActivityRequest,
  FetchDailyScreenActivitySuccess,
  FetchDataAccordingToDaySelectedFailure,
  FetchDataAccordingToDaySelectedRequest,
  FetchDataAccordingToDaySelectedSuccess,
  FetchMealTypeFailure,
  FetchMealTypeRequest,
  FetchMealTypeSuccess,
  FetchPhysicalDailyActivityFailure,
  FetchPhysicalDailyActivityRequest,
  FetchPhysicalDailyActivitySuccess,
  FetchScreenTypeFailure,
  FetchScreenTypeRequest,
  FetchScreenTypeSuccess,
  FetchSearchedDailyMealAndDrinkTrackerListFailure,
  FetchSearchedDailyMealAndDrinkTrackerListRequest,
  FetchSearchedDailyMealAndDrinkTrackerListSuccess,
  FetchSearchedPhysicalDailyActivityFailure,
  FetchSearchedPhysicalDailyActivityRequest,
  FetchSearchedPhysicalDailyActivitySuccess,
  FetchTodTypeFailure,
  FetchTodTypeRequest,
  FetchTodTypeSuccess,
  FetchWeekDaysDetailsFailure,
  FetchWeekDaysDetailsRequest,
  FetchWeekDaysDetailsSuccess
} from './my-journal.actions';
import {catchError, map, mergeMap, of, tap} from "rxjs";
import {MyJournalService} from "./my-journal.service";
import {CommonService} from "src/app/modules/shared/services/common.service";
import {Store} from "@ngrx/store";

@Injectable()
export class MyJournalEffect {

  fetchDailyMeal$ = createEffect(() => this.actions.pipe(ofType(FetchDailyMealAndDrinkTrackerRequest), map(action => {
    return action
  }), mergeMap(payload => {
    return this.myJournalService.fetchDailyMealsList().pipe(map(response => {
      return FetchDailyMealAndDrinkTrackerSuccess({
        payload: response.data
      })
    }), catchError(err => of(FetchDailyMealAndDrinkTrackerFailure())), tap((action: any) => {
      if (action.type === FetchDailyMealAndDrinkTrackerSuccess.type) {
        // Code to execute on API Success Action dispatch
      } else if (action.type === FetchDailyMealAndDrinkTrackerFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
    }))
  })))
  fetchDailyPhysicalActivity$ = createEffect(() => this.actions.pipe(ofType(FetchPhysicalDailyActivityRequest), map(action => {
    return action
  }), mergeMap(payload => {
    return this.myJournalService.fetchDailyPhysicalActivityList()
      .pipe(map(response => {
        return FetchPhysicalDailyActivitySuccess({
          payload: response.data
        })
      }), catchError(err => of(FetchPhysicalDailyActivityFailure())), tap((action: any) => {
        if (action.type === FetchPhysicalDailyActivitySuccess.type) {
          // Code to execute on API Success Action dispatch
        } else if (action.type === FetchPhysicalDailyActivityFailure.type) {
          // Code to execute on API Failure Action dispatch
        }
      }))
  })))
  fetchDailyScreenActivity$ = createEffect(() => this.actions.pipe(ofType(FetchDailyScreenActivityRequest), map(action => {
    return action
  }), mergeMap(payload => {
    return this.myJournalService.fetchDailyScreenActivityList()
      .pipe(map(response => {
        return FetchDailyScreenActivitySuccess({
          payload: response.data
        })
      }), catchError(err => of(FetchDailyScreenActivityFailure())), tap((action: any) => {
        if (action.type === FetchDailyScreenActivitySuccess.type) {
          // Code to execute on API Success Action dispatch
        } else if (action.type === FetchDailyScreenActivityFailure.type) {
          // Code to execute on API Failure Action dispatch
        }
      }))
  })))

  searchedDailyMealList$ = createEffect(() => this.actions.pipe(ofType(FetchSearchedDailyMealAndDrinkTrackerListRequest), map(action => {
    return action.payload
  }), mergeMap(payload => {
    return this.myJournalService.fetchSearchedDailyMealList(payload)
      .pipe(map(response => {
        return FetchSearchedDailyMealAndDrinkTrackerListSuccess({
          payload: response.data
        })
      }), catchError(err => of(FetchSearchedDailyMealAndDrinkTrackerListFailure())), tap((action: any) => {
        if (action.type === FetchSearchedDailyMealAndDrinkTrackerListSuccess.type) {
          // Code to execute on API Success Action dispatch
        } else if (action.type === FetchSearchedDailyMealAndDrinkTrackerListFailure.type) {
          // Code to execute on API Failure Action dispatch
        }
      }))
  })))

  searchedDailyPhysicalActivityList$ = createEffect(() => this.actions.pipe(ofType(FetchSearchedPhysicalDailyActivityRequest), map(action => {
    return action.payload
  }), mergeMap(payload => {
    return this.myJournalService.fetchSearchedDailyPhysicalActivityList(payload)
      .pipe(map(response => {
        return FetchSearchedPhysicalDailyActivitySuccess({
          payload: response.data
        })
      }), catchError(err => of(FetchSearchedPhysicalDailyActivityFailure())), tap((action: any) => {
        if (action.type === FetchSearchedPhysicalDailyActivitySuccess.type) {
          // Code to execute on API Success Action dispatch
        } else if (action.type === FetchSearchedPhysicalDailyActivityFailure.type) {
          // Code to execute on API Failure Action dispatch
        }
      }))
  })))

  fetchWeekDetails$ = createEffect(() => this.actions.pipe(ofType(FetchWeekDaysDetailsRequest), map(action => action.payload), mergeMap(payload => {
    return this.myJournalService.fetchWeekDetails(payload)
      .pipe(map(response => {
          return FetchWeekDaysDetailsSuccess({
            payload: response.data
          })
        }), catchError(err => {
          return of(FetchWeekDaysDetailsFailure())
        }),
        tap((action: any) => {
          if (action.type === FetchWeekDaysDetailsSuccess.type) {
            // Code to execute on API Success Action dispatch
          } else if (action.type === FetchWeekDaysDetailsFailure.type) {
            // Code to execute on API Failure Action dispatch
          }
        }))
  })))

  fetchDataAccordingToDaySelected$ = createEffect(() => this.actions.pipe(ofType(FetchDataAccordingToDaySelectedRequest),
    map(action => {
      return action.payload
    }), mergeMap(payload => {
      return this.myJournalService.fetchDetailsAccordingToDaySelected(payload)
        .pipe(map(response => {
          return FetchDataAccordingToDaySelectedSuccess({
            payload: response.data
          })
        }), catchError(err => of(FetchDataAccordingToDaySelectedFailure())), tap((action: any) => {
          if (action.type === FetchDataAccordingToDaySelectedSuccess.type) {
            // Code to execute on API Success Action dispatch
          } else if (action.type === FetchDataAccordingToDaySelectedFailure.type) {
            // Code to execute on API Failure Action dispatch
          }
        }))
    })))

  fetchMealType$ = createEffect(() => this.actions.pipe(ofType(FetchMealTypeRequest),
    map(action => {
      return action
    }), mergeMap(payload => {
      return this.myJournalService.fetchMealType().pipe(map(response => {
        return FetchMealTypeSuccess({
          payload: response.data
        })
      }), catchError(err => of(FetchMealTypeFailure())), tap((action: any) => {
        if (action.type === FetchMealTypeSuccess.type) {
          // Code to execute on API Success Action dispatch
        } else if (action.type === FetchMealTypeFailure.type) {
          // Code to execute on API Failure Action dispatch
        }
      }))
    })))

  fetchTodType$ = createEffect(() => this.actions.pipe(ofType(FetchTodTypeRequest),
    map(action => {
      return action
    }), mergeMap(payload => {
      return this.myJournalService.fetchTodType().pipe(map(response => {
        return FetchTodTypeSuccess({
          payload: {
            ...response.data
          }
        })
      }), catchError(err => of(FetchTodTypeFailure())), tap((action: any) => {
        if (action.type === FetchTodTypeSuccess.type) {
          // Code to execute on API Success Action dispatch
        } else if (action.type === FetchTodTypeFailure.type) {
          // Code to execute on API Failure Action dispatch
        }
      }))
    })))

  addEJournal$ = createEffect(() => this.actions.pipe(ofType(AddEJournalRequest), map(action => action.payload), mergeMap(payload => {
    this.commonService.startLoading();
    return this.myJournalService.addEJournalDetails(payload)
      .pipe(map(response => {
          this.store.dispatch(FetchDataAccordingToDaySelectedRequest({
            payload:
              {
                date: payload.date,
                ...(payload.forUserId ?
                  {forUserId: payload.forUserId}
                                      : {})
              }
          }))
          return AddEJournalSuccess({payload: payload})
        }), catchError(err => {
          return of(AddEJournalFailure)
        }),
        tap((action: any) => {
          this.commonService.stopLoading();
          if (action.type === AddEJournalSuccess.type) {
            this.myJournalService.onWeekDataAdded.next(true);
            this.commonService.closeDialog();
          } else if (action.type === AddEJournalFailure.type) {
            // Code to execute on API Failure Action dispatch
          }
        }))
  })))

  fetchColorType$ = createEffect(() => this.actions.pipe(ofType(FetchColorTypeRequest),
    map(action => {
      return action
    }), mergeMap(payload => {
      return this.myJournalService.fetchColorType().pipe(map(response => {
        return FetchColorTypeSuccess({
          payload: response.data
        })
      }), catchError(err => of(FetchColorTypeFailure())), tap((action: any) => {
        if (action.type === FetchColorTypeSuccess.type) {
          // Code to execute on API Success Action dispatch
        } else if (action.type === FetchColorTypeFailure.type) {
          // Code to execute on API Failure Action dispatch
        }
      }))
    })))

  deleteMyJournalRecord$ = createEffect(() => this.actions.pipe(ofType(DeleteMyJOurnalRecordsRequest), map(action => action.payload), mergeMap(payload => {
    this.commonService.startLoading();
    return this.myJournalService.deleteMyJournalRecord({
      recordId: payload.recordId, recordType: payload.recordType
    }).pipe(map(response => {
        this.store.dispatch(FetchDataAccordingToDaySelectedRequest({
          payload:
            {
              date: payload.selectedDate?.date,
              ...(payload.memberId ?
                {forUserId: payload.memberId}
                                   : {})
            }
        }))
        return DeleteMyJOurnalRecordsSuccess({
          payload: {
            memberId: payload.memberId,
            selectedDate: payload.selectedDate
          }
        })
      }),
      catchError(err => of(DeleteMyJOurnalRecordsFailure())),
      tap((action: any) => {
        this.commonService.stopLoading();
        if (action.type === DeleteMyJOurnalRecordsSuccess.type) {
          // Code to execute on API Success Action dispatch
        } else if (action.type === DeleteMyJOurnalRecordsFailure.type) {
          // Code to execute on API Failure Action dispatch
        }
      }))
  })))

  editEJournalEntry$ = createEffect(() => this.actions.pipe(ofType(EditRecordsRequest), map(action => action.payload), mergeMap((payload: any) => {
    this.commonService.startLoading();
    return this.myJournalService.editEJournalRecord(payload)
      .pipe(map(response => {
          this.store.dispatch(FetchDataAccordingToDaySelectedRequest({
            payload:
              {
                date: payload?.date,
                ...(payload.forUserId ?
                  {forUserId: payload.forUserId}
                                      : {})
              }
          }))
          return EditRecordsSuccess()
        }), catchError(err => {
          return of(EditRecordsFailure())
        }),
        tap((action: any) => {
          this.commonService.stopLoading();
          if (action.type === EditRecordsSuccess.type) {
            this.commonService.closeDialog();
          } else if (action.type === EditRecordsFailure.type) {
            // Code to execute on API Failure Action dispatch
          }
        }))
  })))

  fetchScreenType$ = createEffect(() => this.actions.pipe(
    ofType(FetchScreenTypeRequest),
    map(action => {
      return action
    }),
    mergeMap(payload => {
      return this.myJournalService.fetchScreenType().pipe(
        map(response => {
          return FetchScreenTypeSuccess({
            payload: response.data
          })
        }),
        catchError(err => of(FetchScreenTypeFailure())),
        tap((action: any) => {
          if (action.type === FetchScreenTypeSuccess.type) {
            // Code to execute on API Success Action dispatch
          } else if (action.type === FetchScreenTypeFailure.type) {
            // Code to execute on API Failure Action dispatch
          }
        }))
    })))

  fetchActivityType$ = createEffect(() => this.actions.pipe(
    ofType(FetchActivityTypeRequest),
    map(action => {
      return action
    }),
    mergeMap(payload => {
      return this.myJournalService.fetchActivityType().pipe(
        map(response => {
          return FetchActivityTypeSuccess({
            payload: response.data
          })
        }),
        catchError(err => of(FetchActivityTypeFailure())),
        tap((action: any) => {
          if (action.type === FetchActivityTypeSuccess.type) {
            // Code to execute on API Success Action dispatch
          } else if (action.type === FetchActivityTypeFailure.type) {
            // Code to execute on API Failure Action dispatch
          }
        }))
    })))

  constructor(
    private actions: Actions,
    private myJournalService: MyJournalService,
    private commonService: CommonService,
    private store: Store
  ) {
  }

}
